/* eslint-disable */

const awsmobile = {
  "aws_project_region": "eu-west-2",
  "aws_cognito_region": "eu-west-2",
  "aws_user_pools_id": "eu-west-2_7P6uRRi2j",
  "aws_user_pools_web_client_id": "5e0tjpcidea9a3dgdf3jm6hq7",
  "oauth": {
    "domain": "register.winerz.com",
    "responseType": "token",
    "scope": [
      "phone",
      "email",
      "openid",
      "profile",
      "aws.cognito.signin.user.admin"
    ],
    "redirectSignIn": "https://auth.winerz.com/oauth-signin",
    "redirectSignOut": "https://auth.winerz.com/oauth-signout"
  },
  Auth: {
    // (optional) - Configuration for cookie storage
    // Note: if the secure flag is set to true, then the cookie transmission requires a secure protocol
    cookieStorage: {
      // - Cookie domain (only required if cookieStorage is provided)
      domain: '.winerz.com',
      // (optional) - Cookie path
      path: '/',
      // (optional) - Cookie expiration in days
      expires: 365,
      // (optional) - See: https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Set-Cookie/SameSite
      sameSite: "lax", //"strict" | 
      // (optional) - Cookie secure flag
      // Either true or false, indicating if the cookie transmission requires a secure protocol (https).
      secure: true
    },
  },
  API: {
    endpoints: [
      {
        name: "awgapi",
        endpoint: "https://api.winerz.com/api"
      }
    ]
  },
  "federationTarget": "COGNITO_USER_POOLS"
};


export default awsmobile;
